import {
  Button,
  Divider,
  Drawer,
  notification,
  Row,
  Space,
  Spin,
  Upload,
} from "antd";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Checkbox1,
  Date2,
  Date4,
  DateRange4,
  DateRange5,
  Select2,
  Text2,
} from "../../../../Components/FormComponents/InputFields";
import {
  AddGeoTagEmployeeApi,
  GeoTagExcelUploadApi,
} from "../../../../Services/GeoTag";
import { MdInbox } from "react-icons/md";
import { HiDownload } from "react-icons/hi";
import employeeTemplateForAssets from "../../../../Assets/Files/sample_employee_template_for_assets.xlsx";
import employeeTemplate from "../../../../Assets/Files/sample_geotag_employee_excel.xlsx";
import {
  checkPleaseLogin,
  download,
} from "../../../../Services/GeneralFunctions";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import AssetReq from "./AssetReq";

const { Dragger } = Upload;

export default function AddEmployee({ open, onClose, getEmployeesData }) {
  const navigate = useNavigate();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const [api, contextHolder] = notification.useNotification();

  const [fileList, setFileList] = useState([]);
  const [toggleDisable, setToggleDisable] = useState(false);
  const [geotagEnable, setGeotagEnable] = useState(true);

  const [submitLoader, setSubmitLoader] = useState(false);

  const onSubmit = async (val) => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }

    try {
      const res = await AddGeoTagEmployeeApi(val, geotagEnable);

      if (
        res.data.message === "Please Login." ||
        res.data.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }
      if (res?.data?.success) {
        api.success({
          message: res?.data?.message,
          placement: "top",
        });
        getEmployeesData();
        onClose();
      } else {
        api.error({
          message: res?.data?.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        placement: "top",
      });
    }
  };

  const handleExcelSubmit = async () => {
    const res = await checkPleaseLogin(navigate);
    if (res) {
      return;
    }

    let formData = new FormData();
    formData.append("employee_list", fileList[0]);

    try {
      setSubmitLoader(true);
      const data = await GeoTagExcelUploadApi(formData);
      setSubmitLoader(false);

      if (
        data?.data?.message === "Please Login." ||
        data?.data?.message === "Invalid Access Token"
      ) {
        navigate("/auth");
      }

      if (data?.data?.success === false) {
        api.error({
          message: data?.data?.message,
          placement: "top",
        });
      } else {
        api.success({
          message: "File is Submitted Successfully!",
          description: "Please Check the Downloaded Result File for Status.",
          placement: "top",
        });
        download(
          new Blob([data.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
          }),
          "result.xlsx"
        );
      }
    } catch (err) {
      setSubmitLoader(false);

      api.error({
        message: err.message,
        placement: "top",
      });
    }

    onClose();
  };

  const onExcelUpload = (temp, val) => {
    setToggleDisable(true);

    if (
      val[0].type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      val[0].type === "application/vnd.ms-excel"
    ) {
      setFileList(val);
      return false;
    } else {
      return Upload.LIST_IGNORE;
    }
  };

  useEffect(() => {
    reset();
    setFileList([]);
    setToggleDisable(false);
  }, [onClose]);

  return (
    <>
      {contextHolder}
      <Drawer
        title="Create a new employee"
        onClose={onClose}
        open={open}
        contentWrapperStyle={{ width: "100vw" }}
        bodyStyle={{
          paddingBottom: 80,
        }}
        footer={
          <Space size="middle">
            <Button size="large" onClick={onClose}>
              Cancel
            </Button>
            <Button
              size="large"
              onClick={
                toggleDisable ? handleExcelSubmit : handleSubmit(onSubmit)
              }
              type="primary"
              disabled={submitLoader}
            >
              {submitLoader && (
                <Spin
                  className="mr-2 mb-2"
                  size="default"
                  indicator={<LoadingOutlined className="text-light" />}
                  spinning={true}
                />
              )}
              Submit
            </Button>
          </Space>
        }
        footerStyle={{ textAlign: "right" }}
      >
        {/* <Checkbox1 control={control} errors={errors} id='geotagCheckbox' name='For GeoTag' onChange={(val) => setGeotagEnable(val.target.checked)} defaultChecked={geotagEnable} disabled={toggleDisable} /> */}

        <Row>
          <Text2
            control={control}
            errors={errors}
            validations={{ required: true }}
            id="name"
            name="Name"
            disabled={toggleDisable}
          />
          <Text2
            control={control}
            errors={errors}
            validations={{ required: true }}
            id="employeeId"
            name="Employee ID"
            disabled={toggleDisable}
          />
          <Text2
            control={control}
            errors={errors}
            validations={{ required: true }}
            id="biometricId"
            name="Biometric ID"
            disabled={toggleDisable}
          />

          <Text2
            control={control}
            errors={errors}
            validations={{ required: true }}
            id="managerName"
            name="Manager Name"
            disabled={toggleDisable}
          />
          <Text2
            control={control}
            errors={errors}
            validations={{ required: true }}
            id="managerEmail"
            name="Manager Email"
            disabled={toggleDisable}
          />
          <Text2
            control={control}
            errors={errors}
            validations={{ required: true }}
            id="managerId"
            name="Manager ID"
            disabled={toggleDisable}
          />
          {geotagEnable && (
            <Text2
              control={control}
              errors={errors}
              validations={{ required: true }}
              id="email"
              name="Official Email"
              disabled={toggleDisable && geotagEnable}
            />
          )}
          <Select2
            control={control}
            errors={errors}
            id="company"
            name="Company"
            options={[
              {
                label: "DJT Corporation & Investments Pvt Ltd",
                value: "DJT Corporation & Investments Pvt Ltd",
              },
              {
                label: "IndoGulf Hospital & Diagnostics",
                value: "IndoGulf Hospital & Diagnostics",
              },
            ]}
          />

          {!geotagEnable && (
            <>
              <div style={{ width: "100%" }}></div>
              <Date2
                control={control}
                errors={errors}
                validations={{ required: true }}
                id="dob"
                name="Date of Birth"
                disabled={toggleDisable && geotagEnable}
              />
              <Date2
                control={control}
                errors={errors}
                validations={{ required: true }}
                id="doj"
                name="Date of Joining"
                disabled={toggleDisable && geotagEnable}
              />

              <Text2
                control={control}
                errors={errors}
                validations={{ required: true }}
                id="personalEmail"
                name="Personal Email"
                disabled={toggleDisable && geotagEnable}
              />
              <Text2
                control={control}
                errors={errors}
                validations={{ required: true }}
                id="personalMobile"
                name="Personal Mobile No"
                disabled={toggleDisable && geotagEnable}
              />

              <Text2
                control={control}
                errors={errors}
                validations={{ required: true }}
                id="designation"
                name="designation"
                disabled={toggleDisable && geotagEnable}
              />
              <Text2
                control={control}
                errors={errors}
                validations={{ required: true }}
                id="location"
                name="Location"
                disabled={toggleDisable && geotagEnable}
              />
              <Text2
                control={control}
                errors={errors}
                validations={{ required: true }}
                id="department"
                name="Department"
                disabled={toggleDisable && geotagEnable}
              />
              {/* <Text2 control={control} errors={errors} validations={{ required: true }} id='vertical' name=' Business Vertical' disabled={toggleDisable && geotagEnable} /> */}
            </>
          )}

          <Divider>OR</Divider>

          {geotagEnable && (
            <a
              href={employeeTemplate}
              download="sample_employee_template"
              className="mb-3"
              style={{ width: "100%" }}
            >
              <Button block size="large" className="flex justify-center">
                <HiDownload className="fs-5 mx-2" />
                <span> Sample Excel Template</span>
              </Button>
            </a>
          )}
          {!geotagEnable && (
            <a
              href={employeeTemplateForAssets}
              download="sample_employee_template"
              className="mb-3"
              style={{ width: "100%" }}
            >
              <Button
                block
                size="large"
                icon={<HiDownload className="fs-5 mx-2" />}
              >
                Sample Excel Template For Asset Management
              </Button>
            </a>
          )}

          <Dragger
            className="w-100"
            beforeUpload={onExcelUpload}
            listType="picture"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            maxCount={1}
            fileList={fileList}
            onRemove={() => {
              setFileList([]);
              setToggleDisable(false);
            }}
          >
            <p className="ant-upload-drag-icon flex justify-center">
              <MdInbox className="fs-1 text-info" />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
              Support for a single excel file.
              <br />
              <br />
              You can download the template excel file to fill employees details
              using button above.
            </p>
          </Dragger>
        </Row>
      </Drawer>
    </>
  );
}
